<template>
  <header class="header">
    <div v-if="AuthUser === 'Admin'">
      <div class="header__logo">
        <a href="#" target="_blank">
          <router-link to="/dashboard">
            <img
              src="./../../assets/images/hrdesk-logo-dark-beta.png"
              alt="logo"
            />
          </router-link>
        </a>
      </div>

      <div class="header__nav">
        <div class="header__navbar">
          <div class="header__navbar--wallet">
            Wallet Balance:
            <span v-show="loading">loading...</span>
            <span
              :class="{ 'fetching-balance': fetchingBalance }"
              v-show="!loading"
              >₦{{ formattedWalletBalance }}</span
            >
          </div>

          <div class="refresh-btn" @click="refreshCompanyData">
            <span
              ><img
                class="refresh--image"
                src="./../../assets/images/refresh.svg"
                alt="logo"
            /></span>
          </div>

          <div
            v-show="mobileView"
            @click="showNav = !showNav"
            class="menu-icon"
          >
            <span v-if="showNav">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path
                  d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
                />
              </svg>
            </span>
            <span v-else>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                <path
                  d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                />
              </svg>
            </span>
          </div>

          <div
            v-show="mobileView"
            :class="{ open: showNav }"
            class="mobile-nav"
          >
            <div>
              <div class="f_profile" v-show="mobileView">
                <div class="f_profile_header" @click="dropDown">
                  <span @click="dropDown">
                    <svg
                      class="f_profile_avatar"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                    >
                      <path
                        d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"
                      />
                    </svg>
                  </span>
                  {{ userName }}
                </div>

                <div class="f_profile_dropdown" v-if="headerDropDown">
                  <div>
                    <routerLink :to="'/employees/' + userID"
                      >Edit Profile</routerLink
                    >
                  </div>
                  <div @click="logOut">Log Out</div>
                </div>
              </div>
              <mobileSidebar />
            </div>
          </div>

          <div class="header__navbar--profile" v-show="!mobileView">
            <div class="header__navbar--profile-name" @click="dropDown">
              {{ userName }}
            </div>
            <div class="header__navbar--profile-avatar" @click="dropDown">
              <img src="./../../assets/images/user.svg" alt />
            </div>
            <div class="header__navbar--profile-dropdown" v-if="headerDropDown">
              <div>
                <routerLink :to="'/employees/' + userID"
                  >Edit Profile</routerLink
                >
              </div>
              <div @click="logOut">Log Out</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import * as types from "../../store/constant";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import mobileSidebar from "../partials/mobileSidebar.vue";

export default {
  name: "Header",
  components: {
    mobileSidebar,
  },
  data() {
    return {
      userID: null,
      userName: "Loading",
      headerDropDown: false,
      AuthUser: null,
      loading: true,
      walletBalance: "0.00",
      fetchingBalance: false,
      mobileView: false,
      showNav: true,
    };
  },
  computed: {
    formattedWalletBalance() {
      return this.$store.state.walletBalance
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
  },

  mounted() {
    this.checkMobileView();
    window.addEventListener("resize", this.checkMobileView);
  },
  methods: {
    refreshCompanyData() {
      this.getCompanyData();
    },
    checkMobileView() {
      this.mobileView = window.innerWidth <= 768;
    },
    dropDown() {
      if (this.headerDropDown) {
        this.headerDropDown = false;
      } else {
        this.headerDropDown = true;
      }
    },
    logOut() {
      this.$store
        .dispatch(types.AUTH_LOGOUT)
        .then(() => {
          this.$router.push("/login");
        })
        .catch();
    },
    getWalletBalance(data) {
      this.fetchingBalance = true;

      this.$http
        .get(`${types.COMPANY_WALLET}/${data.wallet_number} `)
        .then((resp) => {
          this.fetchingBalance = false;

          if (resp.data.data) {
            this.$store.state.walletBalance = resp.data.data.balance;
          }
          this.loading = false;
        })
        .catch(() => {
          this.fetchingBalance = false;
        });
    },
    getManagerLevel() {
      if (!this.$store.state.managedClient) {
        const companyId =
          this.$store.getters.currentAuthUser.employees.company_id;
        this.$http.get(`${types.COMPANY_GET_API}/${companyId}`).then((resp) => {
          this.$store.state.managedClient = resp.data.data.managed;
        });
      }
    },
    getCompanyData() {
      let user = this.$store.getters.currentAuthUser;
      if (user.employees) {
        this.$http
          .get(`${types.COMPANY_GET_API}/${user.employees.company_id}`)
          .then((resp) => {
            this.getWalletBalance(resp.data.data);
          })
          .catch();
      } else {
        this.loading = false;
        this.walletBalance = "0.00";
        this.$router.push("/login");
      }
    },
    getUser() {
      this.loading = true;
      let user = this.$store.getters.currentAuthUser;
      this.userID = user.employees.id;
      this.userName = user.firstname + " " + user.lastname;
      if (user.roles.name) {
        this.AuthUser = user.roles.name;
      } else {
        this.$router.push("/login");
      }
    },
  },
  created() {
    this.getUser();
    this.getCompanyData();
    this.getManagerLevel();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobileView);
  },
};
</script>

<style lang="scss" scoped>
.f_profile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  background: #f3e6db;
  position: relative;

  .f_profile_header {
    margin-left: 0.8rem;
    font-weight: 700;
  }

  .f_profile_avatar {
    height: 1.5rem;
    width: 1.5rem;
    margin-right: 0.5rem;
  }

  .f_profile_dropdown {
    margin: 0;
    position: absolute;
    top: 1rem;
    right: 0;
    background: #ebebf2;
    padding: 1rem;
    width: 8rem;
  }
}

.mobile-nav {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 20rem;
  height: 100vh;
  background: #ffffff;
  transition: 1s transform;
  margin-top: 5rem;
}

.open {
  transform: translateX(-400px);
}

.menu-icon {
  height: 1.5rem;
  width: 1.5rem;
  margin-left: 1rem;
}

.fetching-balance {
  opacity: 0.5;
}

.refresh--image {
  width: 10px;
  cursor: pointer;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999999;
  // min-width: 1000px;
  height: 4rem;
  padding: 10px 1.563vw 10px 1.563vw;
  background-color: #ffffff;

  > div {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    align-content: center;

    > .header__logo {
      max-width: 7rem;
      padding-top: 0;

      @media (max-width: 768px) {
        max-width: 5rem;
      }

      > a {
        img {
          width: 100%;
        }
      }
    }

    .refresh-btn {
      padding: 0.7rem;
      width: 2.5rem;
      font-size: 0.75rem;
      display: flex;
      justify-content: center;
    }

    > .header__nav {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: flex-end;
      align-content: center;

      > .header__navbar {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-end;
        align-content: center;

        > .header__navbar--wallet {
          // width: calc(100% - 15rem);
          font-size: 1rem;
          font-weight: 200;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.17;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
          text-align: right;

          > span {
            font-weight: 600;
            color: #e57414;
            font-size: 1.25rem;
          }

          ::placeholder {
            color: #caced5;
            opacity: 1;
          }

          ::-ms-input-placeholder {
            color: #caced5;
          }

          ::-ms-input-placeholder {
            color: #caced5;
          }
        }

        > .header__navbar--alert {
          width: 70px;
          padding: 0 10px;

          @media (max-width: 1400px) {
            width: 60px;
          }

          > div {
            border-left: 1px solid #ebebf2;
            border-right: 1px solid #ebebf2;
            height: 50px;
            text-align: center;
            font-size: 1.302rem;
            padding-top: 18px;
            color: #bcbccb;
            position: relative;
            cursor: pointer;

            > div {
              position: absolute;
              top: 13px;
              right: 12px;
              width: 15px;
              height: 15px;
              background: #ffc06a;
              border-radius: 60px;
              overflow: hidden;
              border: 3px solid #fff;
              cursor: pointer;

              @media (max-width: 1400px) {
                right: 6px;
              }
            }
          }
        }

        > .header__navbar--profile {
          width: 160px;
          height: 50px;
          position: relative;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;

          >.header__navbar--profile-name {
            min-width: 100px;
            height: 30px;
            cursor: pointer;
            font-size: 0.833rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.43;
            letter-spacing: normal;
            color: #707070;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding-top: 10px;
          }

          > .header__navbar--profile-avatar {
            width: 30px;
            height: 30px;
            border-radius: 60px;
            text-align: center;
            overflow: hidden;
            cursor: pointer;
          }

          > .header__navbar--profile-dropdown {
            position: absolute;
            top: 50px;
            left: 0;
            width: 100%;
            overflow: hidden;
            background: #fbfafa;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            z-index: 9;

            > div {
              height: 30px;
              padding-left: 20px;
              border-radius: 5px;
              cursor: pointer;
              font-size: 1.042rem;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: flex-start;
              align-content: center;

              > a {
                text-decoration: none;
                color: #000;
              }
            }
          }
        }
      }
    }
  }
}
</style>
